import { cn } from '@neo/lib/utils'
import { backgroundColorOptions } from './note.constants'

type ColorKey = keyof typeof backgroundColorOptions

// Helper function to access color properties more cleanly
const getColorProp = (key: string, prop: keyof (typeof backgroundColorOptions)[ColorKey]) =>
  backgroundColorOptions[key as ColorKey][prop]

export const ColorPicker = ({
  currentBackgroundColor,
  onColorChange,
}: {
  currentBackgroundColor: string
  onColorChange: (color: string) => void
}) => {
  const handleColorChange = (bgColor: string) => {
    onColorChange(bgColor)
  }

  return (
    <div className="grid grid-cols-3 gap-1">
      {Object.keys(backgroundColorOptions).map((bgColor) => (
        <button
          key={bgColor}
          type="button"
          aria-label={bgColor}
          data-testid={`button-bg-${bgColor.toLowerCase()}`}
          className={cn(
            'w-8 h-8 rounded-md cursor-pointer hover:bg-muted flex items-center justify-center',
            currentBackgroundColor === getColorProp(bgColor, 'bg') &&
              'ring-2 ring-offset-1 ring-primary',
          )}
          onClick={() => handleColorChange(bgColor)}
        >
          <div
            className={cn(
              'h-5 w-5 rounded-full border border-primary/20',
              getColorProp(bgColor, 'bg'),
            )}
          />
        </button>
      ))}
    </div>
  )
}
